/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import * as Types from '~/common/types/graphql.ts';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type ChangeRequestReviewType =
  | 'approve'
  | 'batchApprove'
  | 'comment'
  | 'reject';

export type RunBatchChangeRequestReviewsJobInput = {
  batchChangeRequestsJobId: string;
  batchChangeRequestsJobRunId?: string | null | undefined;
  changeRequestIds?: Array<string> | null | undefined;
  comment?: string | null | undefined;
  dryRun?: boolean | null | undefined;
  tenantId: string;
  type: ChangeRequestReviewType;
};

export type SubmitBatchReviewJobMutationVariables = Exact<{
  input: Types.RunBatchChangeRequestReviewsJobInput;
}>;


export type SubmitBatchReviewJobMutation = { cnutSubmitBatchChangeRequestReviewsJob:
    | { __typename: 'BatchChangeRequestReviewsJobSubmitOutput', jobRunId: string }
    | { __typename: 'ValidationError', fields: Array<{ __typename: 'ValidationErrorField', code: string | null, path: string, message: string }> }
   };


export const SubmitBatchReviewJobDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SubmitBatchReviewJob"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"RunBatchChangeRequestReviewsJobInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cnutSubmitBatchChangeRequestReviewsJob"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"BatchChangeRequestReviewsJobSubmitOutput"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jobRunId"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ValidationError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fields"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]}}]} as unknown as DocumentNode<SubmitBatchReviewJobMutation, SubmitBatchReviewJobMutationVariables>;